// src/pages/Login/ResetSuccess/style.ts
import styled from 'styled-components'

export const FullPageWrapper = styled.div`
  background-color: #ffffff;
  color: #1a1a1a;
  font-family: 'Roboto', system-ui, sans-serif;

  width: 100%;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  padding-top: 60px;

  @media (max-width: 480px) {
    padding-top: 40px;
  }
`

export const Logo = styled.img`
  max-height: 40px;
  width: auto;
  margin-bottom: 24px;
`

export const IconCircle = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #22c55e; /* verde */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  font-size: 28px;
  color: #ffffff;
`

export const Title = styled.h1`
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
  color: #1a1a1a;
  margin: 0 0 6px 0;
`

export const Subtitle = styled.p`
  font-size: 0.95rem;
  color: #6b6b6b;
  text-align: center;
  margin: 0 0 24px 0;
`

export const BackRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #0072ce;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const BackIcon = styled.span`
  line-height: 1;
`

export const BackText = styled.span`
  line-height: 1;
`
